/* eslint-disable */

(function () {
    var cookieName = 'cookie-consent';
    var cookie = getCookie(cookieName);
    var yes = 'ja';
    var no = 'nej';

    initCookieBanner();
    initCookieValBlock();
    deleteTrackingCookiesIfDeclined();

    function initCookieBanner() {
        $(window).on('load', function () {
            var cookieBanner = $('#cookie-banner-modal');
            var showBannerOnPage = $('#disable-cookie-consent').length === 0;

            if (cookie === null) {
                deleteTrackingCookies();

                if (showBannerOnPage) {
                    cookieBanner.modal('show');

                    cookieBanner.on('click', '.cookie-knapp-ja', function () {
                        var matomoUrl = this.dataset.matomo;
                        runMatomoAnalytics(matomoUrl)
                        setConsentCookie(yes);
                        updateCookieValBlock();
                        cookieBanner.modal('hide');
                    });
                    cookieBanner.on('click', '.cookie-knapp-nej', function () {
                        setConsentCookie(no);
                        deleteTrackingCookies();
                        updateCookieValBlock();
                        cookieBanner.modal('hide');
                    });
                }
            }
        });
    }

    function initCookieValBlock() {
        $(window).on('load', function () {
            var cookieValBlock = $('.cookievalblock');

            if (cookieValBlock.length) {
                updateCookieValBlock();

                cookieValBlock.on('ifChecked', '#cookieval-ja', function () {
                    var matomoUrl = this.dataset.matomo;
                    runMatomoAnalytics(matomoUrl)
                    setConsentCookie(yes);
                });

                cookieValBlock.on('ifChecked', '#cookieval-nej', function () {
                    setConsentCookie(no);
                    deleteTrackingCookies();
                });
            }
        });
    }

    function updateCookieValBlock() {
        if (cookie === null) {
        } else if (cookie === yes) {
            $('#cookieval-ja').iCheck('check');
        } else {
            $('#cookieval-nej').iCheck('check');
        }
    }

    function setConsentCookie(consent) {
        setCookie(cookieName, consent, 2 * 365, '/');
        cookie = getCookie(cookieName);

        
    }

    function deleteTrackingCookies() {
        var cookies = [
            'nmstat', // Siteimprove
            '__cfduid', // Cloudflare
            'MATOMO_SESSID',
        ];


        var pairs = document.cookie.split(";");
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split("=");

            var trimmed = pair[0].replace(/^\s+|\s+$/gm, '')

            if (trimmed.substring(0, 3) === "_pk") {

                cookies.push(trimmed);
            }
        }

        removeCookiesByName(cookies)

    }

    function deleteTrackingCookiesIfDeclined() {
        if (cookie === no) {
            deleteTrackingCookies();
        }
    }

    function runMatomoAnalytics(matomoUrl) {
        console.log(matomoUrl);
        var _mtm = window._mtm = window._mtm || [];
        _mtm.push({ 'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start' });
        _mtm.push({ 'site': 'MS' });
        (function () {
            var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.async = true; g.src = matomoUrl; s.parentNode.insertBefore(g, s);
        })();
    }


    //function runGoogleAnalytics() {
    //    (function(w, d, s, l, i) {
    //        w[l] = w[l] || [];
    //        w[l].push({
    //            'gtm.start':
    //                new Date().getTime(),
    //            event: 'gtm.js'
    //        });
    //        var f = d.getElementsByTagName(s)[0],
    //            j = d.createElement(s),
    //            dl = l != 'dataLayer' ? '&l=' + l : '';
    //        j.async = true;
    //        j.src =
    //            'https://analytics.alecta.se/gtm.js?id=' + i + dl;
    //        f.parentNode.insertBefore(j, f);
    //    })(window, document, 'script', 'dataLayer', 'GTM-KN3V3S');
    //}

})();
